var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9049L24.7619 21.6669V25.0335L21.1905 21.4621V33.5717H18.8096V21.4621L15.2381 25.0335V21.6669L20 16.9049ZM18.8096 5C23.2441 5 26.9691 8.05001 28.0238 12.1584C28.1274 12.1548 28.2286 12.1429 28.3334 12.1429C32.9274 12.1429 36.6667 15.881 36.6667 20.4763C36.6667 24.6667 33.556 28.1334 29.5238 28.7144V26.3084C32.2369 25.756 34.2858 23.3513 34.2858 20.4763C34.2858 17.1941 31.6155 14.5238 28.3334 14.5238C28.2465 14.531 28.1798 14.5358 28.1119 14.5381L26.1953 14.6096L25.7179 12.7512C24.9048 9.58931 22.0643 7.38095 18.8096 7.38095C14.8905 7.38095 11.6977 10.5548 11.6667 14.4667C11.6691 14.5155 11.6715 14.5631 11.6715 14.6119L11.6881 16.6417L9.68575 16.9786C7.38337 17.3655 5.71433 19.337 5.71433 21.6667C5.71433 24.2929 7.85123 26.4287 10.4762 26.4287V28.8096C6.53695 28.8096 3.33337 25.606 3.33337 21.6667C3.33337 18.1322 5.91552 15.1977 9.29052 14.631C9.29052 14.5953 9.28575 14.5596 9.28575 14.5238C9.28575 9.27264 13.5584 5 18.8096 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.aa062db18b54d078e0b037b8a110b1ce.svg";
export { ForwardRef as ReactComponent };